//*****************************************************************************************************************
//*****************************************************************************************************************
//*************************************(IF YOU HAVE REACHED HERE)**************************************************
//********************************(PLEASE UNDERSTAND THIS PROJECT IS)**********************************************
//****************************************(MADE AND MANAGED BY)****************************************************
//******************************************(KUSHAL VERMA)*********************************************************
//******************************(DON'T TRY TO COPY OR STEAL THIS PROJECT)******************************************
//***********(DO APPRECIATE THE TIME AND EFFORTS THAT I HAVE SPENT IN MAKING THIS PROJECT ALL BY MYSELF)***********
//***************************************(GITHUB: vkushal28)*******************************************************
//****************************(FEEL FREE TO REACH ME OUT FOR ANY QUERIES)******************************************
//**************************(for personal mails : vermakushal.28@gmail.com)****************************************
//*************************(for work related mails : kush.expclick@gmail.com)**************************************
//*****************************************************************************************************************
//*****************************************************************************************************************

import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  sidebarTransition: {
    display: "block",
    float: "left",
    width: "52vw",
    position: "absolute",
    overflowY: "hidden",
    overflowX: "hidden",
    zIndex: "9999",
    backgroundColor: "#ffffff",
    opacity: "10",
    height: "58vh", //changed from 60 to 54
    border: "2px solid black",
    marginTop: "1vh",
    // animation: "1s ease 0s infinite normal none running glitch",
  },
  sidebar: {
    display: "none",
    float: "left",
    width: "203px",
    position: "inherit", //don't change this
    overflowY: "hidden",
    overflowX: "hidden",
    zIndex: "1001",
    backgroundColor: "transparent",
  },
  topName: {
    fontFamily: "Dancing Script, cursive",
    color: "black",
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(1),
    fontSize: "xx-large",
  },

  logoimg: {
    cursor: "pointer",
    width: "90%",
    // marginLeft: theme.spacing(4),
    // marginTop: theme.spacing(1),
    backgroundSize: "cover",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    position: "relative",
    borerRadius: "50%",
  },

  topForMobile: {
    height: "100%",
  },
  categories: {
    color: "#45505b",
    marginTop: theme.spacing(0.5),
    marginLeft: theme.spacing(1),
    textDecoration: "none !important",
    "&:hover": {
      // color: "#fff",
      // backgroundColor: "rgba(131, 193, 252, 1)",
      borderRadius: "50px",
      width: "fit-content",
      transition: "all 0.4s",
      border: "0",
      lineHeight: "1.5",
      textDecoration: "none !important",
    },
  },
  carouselContainer: {
    width: "78vw",
    height: "auto",
    float: "right",
    overflow: "hidden",
    zIndex: "1001",
    position: "inherit",
    padding: "5px",
    // marginTop: "12vh",
    // opacity: "0",
  },
  carousel: {
    width: "90%",
    height: "auto",
    position: "relative",
  },
  carouselSmallScreen: {
    width: "99%",
    height: "auto",
    position: "relative",
  },
  socialMediaIcons: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  specificIcon: {
    width: "fit-content",
    "&:hover": {
      opacity: "0.6",
      // border: "outset",
    },
  },
  otherComponents: {
    width: "95%",
    height: "95vh",
    padding: "6px",
    // overflow: "hidden",
    // marginTop: theme.spacing(2),
    // marginRight: theme.spacing(2),
    // marginBottom: theme.spacing(2),
    // marginLeft: theme.spacing(1),
  },
  contactForm: {
    marginLeft: theme.spacing(2),

    maxWidth: "fit-content",
    height: "auto",
    display: "inherit",
  },
  contactMeLabels: {
    color: "chocolate",
    fontWeight: "bold",
  },
  alertMsg: {
    float: "top right",
    marginTop: theme.spacing(1),
  },
  aboutIcons: {
    width: "80px",
    height: "70px",
  },
  root: {
    // overflowY: "scroll",
    // overflowX: "hidden",
    // height: "60%",
    // maxHeight: "100%",
    marginTop: "1vw",
    // width: "100%",
    zIndex: "1001",
    position: "inherit",
    marginBottom: "2em",
  },
  polaroidOuter: {
    width: "100%",
    height: "96%",
    padding: "0px",
    backgroundColor: "white",
    position:"relative",
    display:"inline-block",
    // border: "1px solid black",
    boxShadow: "4px 16px 20px 7px #524c4c7a",
    "&:hover": {
      // opacity: "0.5",
      // width: "100%",
      filter: "drop-shadow(2px 2px 8px black)"
      // blur(0.8px) 
    },
  },
  polaroidImages: {
    width: "100%",
    height: "auto",
    position: "inherit",
    backgroundColor: "white",
    // display:"block"
  },
  polaroidText: {
    fontFamily: "Inherit",
    fontSize: "initial",
    textAlign: "center",
    position:"absolute",
    bottom:"0",
    width:"initial",
    backgroundColor:"#000000f5",
    opacity:"0.8",
    fontSize:"1 rem",
    right:"0px",
    left:"0px",
    height:"30px",
    color:"white",
    borderRadius:"8px 26px 26px 8px",
    top:"75%"
  },

  root2: {
    flexGrow: 1,
    marginTop: theme.spacing(2),
    overflowY: "hidden",
    overflowX: "hidden",
  },
  gridList: {
    alignItems: "center",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));
